<template>
  <div>
    <!-- 好友邀请开始-->
    <div class="actModules">
      <h3 class="actModules_title" v-text="modulesTitle"></h3>
      <p class="actModules_descripe" v-html="modulesRules"></p>
      <ul class="actInvite_Wrap">
        <li class="actInvite_list" v-for="(inviteLis,index) in inviteList" :key="index">
          <img :src="inviteLis.img">
        </li>
      </ul>
      <div class="actModules_btnWrap" v-for="(item, index) in headBtnInfo" :key="index">
        <p class="actModules_btnDescript" v-text="item.headBtnDesc"></p>
        <a href="javascript:;" class="actModules_btn">{{item.headBtnName}}</a>
      </div>
      <ul class="actInvite_boxWrap">
        <li class="actInvite_boxList" v-for="(inviteBag,index) in giftList" :key="index">
          <p class="actInvite_boxTitle" v-text="inviteBag.title"></p>
          <div class="actInvite_boxContent">
            <div class="actInvite_boxImg">
              <img :src="inviteBag.img">
            </div>
            <div class="actInvite_boxBtnWrap">
              <a href="javascript:;" class="actInvite_boxBtn">{{inviteBag.btnName1}}</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 好友邀请结束-->
  </div>
</template>

<script>
import './../assets/css/reset.css'
import bus from '../../bus'
export default {
	name: 'pc-invite',
	actConfig: {
		labels: { // 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案',
			bgImg: '背景图片',
			modulesRules: '活动规则',
			headBtnInfo: '头部信息',
			headBtn: '头部按钮',
			headBtnDesc: '功能规则',
			headBtnName: '功能按钮',
			headBtnStyle: '头部按钮样式',
			action: '动作',
			giftList: '礼包挡位',
			title: '挡位名称',
			img: '图片',
			btnName1: '功能按钮-领取前',
			btnName2: '功能按钮-领取后',
			style: '按钮样式'
		},
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字',
		},
		modulesRules: {
			type: String,
			default: '活动规则：规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案',
		},
		bgImg: {
			type: String,
			default: '',
		},
		headBtnInfo: {
			type: Array,
			default: function () {
				return [
					{
						headBtnDesc: '规则规则规则规则规则规则规则规则规则规则',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
						},
						headBtnName: '功能按钮',
						headBtnStyle: ''
					}
				]
			}
		},
		giftList: {
			type: Array,
			default: function () {
				return [
					{
						title: '自定义邀请人数礼包名称',
						img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						btnName1: '领取',
						btnName2: '领取成功',
						style: ''
					},
					{
						title: '自定义邀请人数礼包名称',
						img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						btnName1: '领取',
						btnName2: '领取成功',
						style: ''
					},
					{
						title: '自定义邀请人数礼包名称',
						img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						btnName1: '领取',
						btnName2: '领取成功',
						style: ''
					},
				]
			}
		}
	},
	data () {
		return {
			inviteList: [
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' }
			],
		};
	},
	mounted () {
		if (this.$actMode !== 'production') {
			return
		}
		bus.$on('giftReceivedStatus', (isGetedh5) => {
			console.log(isGetedh5)
			if (typeof (isGetedh5) === 'undefined') {
				return
			}
			for (let i = 0; i < this.giftList.length; i++) {
				let idx = this.giftList[i].action.ruleId
				if (typeof (isGetedh5['h' + idx]) !== 'undefined') {
					if (isGetedh5['h' + idx][0] > 0 && isGetedh5['h' + idx][1] === '0') {
						this.$set(this.geted, i, true)
						// this.geted[i] = true
					} else {
						this.geted[i] = false
					}
				} else {
					this.geted[i] = false
				}
			}
			console.log(this.geted)
		})
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "~./../assets/scss/common";

.actInvite_Wrap {
  font-size: 0;
  text-align: center;
  margin: 40px 0;
}

.actModules_btnDescript {
  font-size: 24px;
  color: #4a4a4a;
  text-align: center;
  margin-bottom: 10px;
}

.actInvite_list {
  width: 140px;
  height: 140px;
  overflow: hidden;
  @extend %inline-block;
  @include border-radius();
  margin: 0 21px;

  img {
    width: 100%;
    height: 100%;
  }
}

.actInvite_boxWrap {
  width: 1000px;
  margin: 90px auto 0;
}

.actInvite_boxTitle {
  font-size: 24px;
  color: #4a4a4a;
  margin-bottom: 10px;
}

.actInvite_boxContent {
  background: #d8d8d8;
  padding: 40px 28px;
}

.actInvite_boxContent {
  @extend %clearfix;
}

.actInvite_boxImg {
  @extend %left;
}

.actInvite_boxImg {
  width: 690px;
  height: 250px;
}

.actInvite_boxBtnWrap {
  width: 230px;
  height: 250px;
  @extend %relative;
  @extend %right;
}

.actInvite_boxBtn {
  width: 230px;
  height: 70px;
  line-height: 70px;
  font-size: 28px;
  color: #4a4a4a;
  @extend %block;
  text-align: center;
  background: #e27f7f;
  @extend %absolute;
  left: 50%;
  top: 50%;
  margin-left: -115px;
  margin-top: -35px;
}

.actInvite_boxList {
  width: 1000px;

  & + .actInvite_boxList {
    margin-top: 66px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/pc/templates/x-invite.vue